<script src="../../axios/axios.js"></script>
  
<template>
  <!-- 登录 -->
  <div>
    <Particles></Particles>
    <div class="ingwbos_bxo">
      <div class="loginmain">
        <div class="banner">
          <div class="bannerImg">
            <!-- <div v-for="(v, i) in bannersimg" :key="i" :style="{ opacity: i + 1 == n ? '1' : '0' }" class="active">
              <img :src="v" alt=""/>
            </div> -->
            <canvas id="canvas" class="canvas"></canvas>
          </div>
          <div class="logo_img">
            <img alt="" src="static/img/logo-white.png" />
          </div>
          <div class="con_title">
              数智化课堂
            <div class="scen_title">
              数据驱动能力提升，打造以学生为中心的互动式课堂
            </div>
          </div>
          <div class="secen_imgbox">
            <img alt="" src="static/img/catu.png" />
          </div>
        </div>
        <div v-if="issiginshow" class="login_box">
          <div class="login_midbox">
            <div
              v-if="mimadengl != 4"
              @click="dxdengl(4)"
              class="smdelg_box"
            ></div>
            <div @click="dxdengl(1)" v-else class="fanwgowbox">
              <i class="el-icon-arrow-left"></i> 返回账号登录
            </div>
            <div class="locont_box">
              <div
                v-if="mimadengl == 1 || mimadengl == 2"
                class="login_titlebox"
              >
                登录备课
              </div>
              <div v-else-if="mimadengl == 3" class="login_titlebox">
                重置密码
              </div>
              <div v-else-if="mimadengl == 4" class="login_titlebox">
                扫码登录
              </div>
              <div v-if="mimadengl == 1">
                <div
                  :class="iphoneerror == true ? 'inpuborder' : ''"
                  class="boxlist"
                >
                  <div class="leftbox">
                    <svg aria-hidden="true" class="icon svg-icon">
                      <use xlink:href="#iconzhanghao1"></use>
                    </svg>
                  </div>

                  <div class="rightinput">
                    <input
                      v-model="iphone"
                      autofocus="autofocus"
                      placeholder="请输入手机号"
                      type="text"
                      @blur="entmobile"
                      @keyup.enter="entmobile"
                      @keyup.13="loginfun(1)"
                    />
                  </div>
                </div>

                <div
                  :class="passworderr == true ? 'inpuborder' : ''"
                  class="boxlist"
                >
                  <div class="leftbox">
                    <svg aria-hidden="true" class="icon svg-icon">
                      <use xlink:href="#iconmima1"></use>
                    </svg>
                  </div>

                  <div class="rightinput">
                    <input
                      v-model="password"
                      autofocus="autofocus"
                      placeholder="请输入密码"
                      type="password"
                      @blur="entpassword"
                      @keyup.enter="entpassword"
                      @keyup.13="loginfun(1)"
                    />
                  </div>
                </div>
                <!-- -->
                <div class="loginbtn" @click="loginfun(1)">确定</div>
                <div v-if="inputError" class="errorbox">
                  <svg aria-hidden="true" class="icon svg-icon">
                    <use xlink:href="#iconjinggao"></use>
                  </svg>
                  &nbsp; {{ errortext }}
                </div>
                <div v-else style="height: 2.571429rem"></div>

                <div class="bottomzw_box">
                  <div class="lowgsigbtn">
                    <span @click="dxdengl(2)">短信登录</span> |
                    <span @click="dxdengl(3)">忘记密码</span>
                  </div>
                </div>
              </div>

              <div v-else-if="mimadengl == 2">
                <div
                  :class="iphoneerror == true ? 'inpuborder' : ''"
                  class="boxlist"
                >
                  <div class="leftbox">
                    <svg aria-hidden="true" class="icon svg-icon">
                      <use xlink:href="#iconzhanghao1"></use>
                    </svg>
                  </div>

                  <div class="rightinput">
                    <input
                      v-model="iphone"
                      autofocus="autofocus"
                      placeholder="请输入手机号"
                      type="text"
                    />
                  </div>
                </div>

                <div :class="codeerror ? 'inpuborder' : ''" class="boxlist">
                  <div class="codebox">
                    <input
                      v-model="code"
                      placeholder="请输入4位数验证码"
                      type="text"
                      @blur="entpcode"
                      @keyup.enter="entpcode"
                    />
                  </div>
                  <div class="lulwd"></div>
                  <div class="codebtnbox" @click="getmessage(1)">
                    {{ codetext }}
                  </div>
                </div>
                <div class="loginbtn" @click="loginfun(2)">确定</div>
                <div v-if="inputError" class="errorbox">
                  <svg aria-hidden="true" class="icon svg-icon">
                    <use xlink:href="#iconjinggao"></use>
                  </svg>
                  &nbsp; {{ errortext }}
                </div>
                <div v-else class="errorbox1"></div>

                <div @click="dxdengl(1)" class="lowgsigbtn">
                  <i class="el-icon-arrow-left"></i> 返回账号登录
                </div>
              </div>

              <div v-else-if="mimadengl == 3">
                <div
                  :class="iphoneerror == true ? 'inpuborder' : ''"
                  class="boxlist"
                >
                  <div class="leftbox">
                    <svg aria-hidden="true" class="icon svg-icon">
                      <use xlink:href="#iconshouji"></use>
                    </svg>
                  </div>

                  <div class="rightinput">
                    <input
                      v-model="iphone"
                      autofocus="autofocus"
                      placeholder="请输入手机号"
                      type="text"
                      @blur="entmobile"
                      @keyup.enter="entmobile"
                    />
                  </div>
                </div>

                <div
                  :class="passworderr == true ? 'inpuborder' : ''"
                  class="boxlist"
                >
                  <input
                    v-model="password"
                    autofocus="autofocus"
                    class="resgist_ipnut"
                    placeholder="请输入密码（6-20位数字或字母）"
                    type="password"
                    @blur="entpassword1"
                    @keyup.enter="entpassword1"
                  />
                </div>

                <div
                  :class="codeerror == true ? 'inpuborder' : ''"
                  class="boxlist"
                  @blur="entpcode"
                  @keyup.enter="entpcode"
                >
                  <div class="codebox">
                    <input
                      autofocus="autofocus"
                      class="resgist_ipnut"
                      v-model="code"
                      placeholder="请输入4位数验证码"
                      type="text"
                      @blur="entpcode"
                      @keyup.enter="entpcode"
                    />
                  </div>
                  <div class="lulwd"></div>
                  <div class="codebtnbox" @click="getmessage(3)">
                    {{ codetext }}
                  </div>
                </div>

                <div class="loginbtn" @click="resetPassfun">确定</div>
                <div
                  v-if="inputError"
                  class="errorbox"
                  style="margin-top: 1rem"
                >
                  <svg aria-hidden="true" class="icon svg-icon">
                    <use xlink:href="#iconjinggao"></use>
                  </svg>
                  &nbsp; {{ errortext }}
                </div>
                <div
                  @click="dxdengl(1)"
                  class="lowgsigbtn"
                  style="margin-top: 1rem"
                >
                  <i class="el-icon-arrow-left"></i> 返回账号登录
                </div>
              </div>

              <div v-else>
                <div class="clow_erbox">
                  <vueQrs
                    style="width: 18rem; height: 18rem; margin-top: 1.7rem"
                    ref="qrImg"
                    :margin="0"
                    :text="qrTeacher1.url"
                    colorLight="#fff"
                  ></vueQrs>
                </div>
              </div>
            </div>
          </div>

          <div class="qerw_box">
            <div class="login_titlebox">扫码上课</div>
            <div class="clow_erbox">
              <vueQrs
                style="width: 18rem; height: 18rem; margin-top: 1.7rem"
                ref="qrImg"
                :margin="0"
                :text="qrTeacher.url"
                colorLight="#fff"
              ></vueQrs>
            </div>
            <div class="twi_box">小程序进入课堂，扫码投屏</div>

            <!-- <div v-if="qrTeacher.url" class="qr_box"> 
               <vueQrs ref="qrImg" :margin="0" :text="qrTeacher.url" colorLight="#fff"></vueQrs>
            </div> -->
          </div>
        </div>

        <div v-if="isforgetthepassword" class="login_box">
          <div class="login_midbox">
            <div class="registtop_text">找回密码</div>
            <div
              :class="iphoneerror == true ? 'inpuborder' : ''"
              class="boxlist"
            >
              <div class="leftbox">
                <svg aria-hidden="true" class="icon svg-icon">
                  <use xlink:href="#iconshouji"></use>
                </svg>
              </div>

              <div class="rightinput">
                <input
                  v-model="iphone"
                  autofocus="autofocus"
                  placeholder="请输入手机号"
                  type="text"
                  @blur="entmobile"
                  @keyup.enter="entmobile"
                />
              </div>
            </div>

            <div
              :class="passworderr == true ? 'inpuborder' : ''"
              class="boxlist"
            >
              <input
                v-model="password"
                autocomplete="new-password"
                autofocus="autofocus"
                class="resgist_ipnut"
                placeholder="请输入密码（6-20位数字或字母）"
                type="password"
                @blur="entpassword1"
                @keyup.enter="entpassword1"
              />
            </div>

            <div
              :class="codeerror == true ? 'inpuborder' : ''"
              class="boxlist"
              @blur="entpcode"
              @keyup.enter="entpcode"
            >
              <div class="codebox">
                <input
                  v-model="code"
                  placeholder="请输入4位数验证码"
                  type="text"
                  @blur="entpcode"
                  @keyup.enter="entpcode"
                />
              </div>
              <div class="lulwd"></div>
              <div class="codebtnbox" @click="getmessage(3)">
                {{ codetext }}
              </div>
            </div>

            <div class="loginbtn" @click="resetPassfun">确定</div>
            <div v-if="inputError" class="errorbox" style="margin-top: 1rem">
              <svg aria-hidden="true" class="icon svg-icon">
                <use xlink:href="#iconjinggao"></use>
              </svg>
              &nbsp; {{ errortext }}
            </div>
            <div v-else class="errorbox1" style="margin-top: 1rem"></div>
            <div class="cokebox" @click="gotosigin">返回登录</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isresetshow" class="tbox">
      <div class="czmgbox">
        <div class="sucestext">密码重置成功</div>
        <div class="loadtext">正在登录中...</div>
      </div>
    </div>

    <div v-if="showpassowedbox" class="poswad_box">
      <div class="tx_box">
        <img v-if="touximg" :src="touximg" alt="" @error="getError" />
        <img v-else :src="avatardefaultimg" alt="" />
      </div>

      <div class="poswinputbox">
        <div class="leftbox">
          <svg aria-hidden="true" class="icon svg-icon">
            <use xlink:href="#iconmima1"></use>
          </svg>
        </div>
        <div class="mind_box">
          <input
            id="chatInput"
            v-model="password"
            autocomplete="off"
            autofocus="autofocus"
            placeholder="请输入密码"
            type="password"
            @blur="entpassword1"
            @keyup.enter="entpassword1"
          />
        </div>

        <div class="last_box" @click="loginfun(1)">
          <i class="el-icon-right"></i>
        </div>
      </div>

      <!-- -->
      <div v-if="inputError" class="errorboxs">
        <svg aria-hidden="true" class="icon svg-icon">
          <use xlink:href="#iconjinggao"></use>
        </svg>
        &nbsp; {{ errortext }}
      </div>

      <div class="cclose_btn" @click="closeposed">
        <svg aria-hidden="true" class="icon svg-icon">
          <use xlink:href="#iconguanbi"></use>
        </svg>
      </div>
    </div>

    <div v-if="issisyshow" class="close_box">
      <div class="cclose_btn" @click="closesity">
        <svg aria-hidden="true" class="icon svg-icon">
          <use xlink:href="#iconguanbi"></use>
        </svg>
      </div>

      <div class="min_contbox">
        <div class="divbox" @click="Exitsystem">
          <img alt="" src="static/img/tcxt.png" />
          <div class="text_wod">退出系统</div>
        </div>
      </div>
    </div>

    <div v-if="isyzmshow" class="tbox">
      <div class="yzmbox">
        <div class="sucestext">验证码发送成功</div>
        <div class="loadtext">请注意查收</div>
      </div>
    </div>

    <div v-if="iszhjyshow" class="tbox">
      <div class="zhbox">
        <div class="sucestext">账号已禁用</div>
        <div class="loadtext">请联系管理员进行处理！</div>
      </div>
    </div>

    <div v-if="isovertime" class="tbox">
      <div class="verifybox">
        <slide-verify
          :h="155"
          :l="42"
          :r="10"
          :slider-text="text"
          :w="310"
          @fail="onFail"
          @refresh="onRefresh"
          @success="onSuccess"
        ></slide-verify>
        <div>{{ msg }}</div>
      </div>
    </div>

    <div
      id="model_place"
      style="
        width: 1%;
        height: 1%;
        position: fixed;
        background: #fff;
        color: #000;
        top: -10000px;
        left: -10000px;
      "
    ></div>
  </div>
</template>

<script>
import vueQrs from "vue-qr";

import Particles from "@/components/particles/index";

export default {
  props: {
    value: {
      type: [Object, Array],
      default: () => {},
    },
  },
  data() {
    return {
      mimadengl: 1,
      bannersimg: ["static/img/loginhonmebg.png"],
      bannersimg1: ["static/img/loginbg.png"],
      avatardefaultimg: "static/img/avatardefault.png",
      n: 1, // 图片的index。
      bFlag: true, // 锁定
      timer1: "", // 这是bFlag定时器的数据
      timer2: "", // 这是自动播放（next（））定时器的数据
      timer3: "", // 这是打开浏览器时，初始运动定时器的数据
      activeName: "first",
      iszhture: false,
      iphone: "",
      password: "",
      errortext: "该手机号尚未注册",
      codetext: "获取验证码",
      code: "",
      codeerror: false,
      inputError: false,
      passworderr: false,
      miao: 60,
      iphoneerror: false,
      machine_code: "",
      isregister: false, //注册
      isadminregister: false, //管理员注册
      isforgetthepassword: false, //忘记密码
      issiginshow: true,
      username: "",
      errorusername: false,
      gender: 1,
      ishit: false,
      isresetshow: false,
      userList: [],
      touximg: "",
      showpassowedbox: false,
      iszhangh: false,
      issisyshow: false,
      msg: "",
      text: "向右滑",
      isovertime: false,
      contime: 0,
      goon: true,
      isyzmshow: false,
      iszhjyshow: false,
      ishitres: false,
      visible: false,
      layout: "normal",
      input: null,
      interval: null,
      fullsecr: false,
      local_domain: "",
      path: "wss://welcome.seeonce.cn:9502",
      // path: " wss://dat.seeonce.cn:9501",
      screen: "",
      qrTeacher: {},
      qrTeacher1: {},
      istz: false,
      timeouts: 20000,
      ishowqr: false,
      timeoutObj: null,
      timlws: 0,
      curdata: "",
      options: {
        useKbEvents: false,
        preventClickEvent: false,
      },
      mouse: "",
      originx: "",
      originy: "",
      int: "",
      cvs: "",
    };
  },

  methods: {
    fullScreen() {
      this.fingerprintLogin();
      this.fullsecr = false;
      var el = document.body;
      var rfs =
          el.requestFullScreen ||
          el.webkitRequestFullScreen ||
          el.mozRequestFullScreen ||
          el.msRequestFullScreen,
        wscript;
      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el);
        return;
      }
      if (typeof window.ActiveXObject != "undefined") {
        wscript = new ActiveXObject("WScript.Shell");
        if (wscript) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    dxdengl(id) {
      this.inputError = false;
      this.mimadengl = id;
    },

    accept(text) {
      this.hide();
    },
    show(e) {
      this.input = e.target;
      this.layout = e.target.dataset.layout;
      if (!this.visible) this.visible = true;
    },
    hide() {
      this.entpassword1();
      this.visible = false;
    },
    onSuccess() {
      this.msg = "成功";
      this.isovertime = false;
      this.goon = false;
    },
    onFail() {
      this.msg = "";
    },
    onRefresh() {
      this.msg = "";
    },

    //错误图片处理
    getError(event) {
      var img = event.srcElement;
      img.src = require("../../../static/img/avatardefault.png"); //替换的图片
      img.onerror = null; //控制不要一直触发错误
    },

    next() {
      // 下一张
      // 为了避免连续点击。让bFlag运动结束后再变为true。
      if (this.bFlag) {
        this.bFlag = false;
        this.clearT(); // 运动之前，清除所有定时器。
        this.n = this.n + 1 == 3 ? 1 : this.n + 1; // 下一张，如果是第4张，就返回第一张。
        // 调用timeout函数，延迟进入下一次轮播，以便可以点击切换。
        this.timeout();
      }
    },
    clearT() {
      //清除所有定时器
      clearTimeout(this.timer1);
      clearTimeout(this.timer2);
      clearTimeout(this.timer3);
    },
    timeout() {
      // 运动结束后设置bFlag为true，并且3秒后调用next，进行下一次运动。
      // 运动时间是1s。
      this.timer2 = setTimeout(() => {
        this.bFlag = true;
      }, 1000);
      this.timer1 = setTimeout(() => {
        this.next();
      }, 3000);
    },
    change(num) {
      // 点击按钮，切换到对应图片，需要获取index。
      if (this.bFlag) {
        this.bFlag = false;
        this.clearT();
        this.n = num; // 将显示图片变为选中的那一张。
        this.timeout();
      }
    },

    handleClick(tab, event) {
      this.iphone = "";
      this.password = "";
      this.code = "";
      this.inputError = false;
      this.iphoneerror = false;
      this.codeerror = false;
      if (this.activeName == "first") {
        if (this.interval) {
          window.clearInterval(this.interval);
          this.interval = null;
        }

        this.ishit = false;
        this.miao = 60;
        this.codetext = "获取验证码";
      }
    },
    //获取短信验证码
    getmessage(id) {
      this.inputError = false;
      this.iphoneerror = false;
      var myreg =
        /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
      if (!myreg.test(this.iphone)) {
        this.inputError = true;
        this.iphoneerror = true;
        this.errortext = "请输入有效手机号码！";
        // setTimeout(() => {
        //   this.ispiphone=false;
        // }, 3500);
        // setTimeout(() => {
        //   this.inputError = false;
        //   this.ispiphone=false;
        // }, 3500);
        return false;
      } else {
        var resetPass1 = "login";
        if (id == 1) {
          resetPass1 = "login";
        } else if (id == 2) {
          var reg = /^[\u0391-\uFFE5A-Za-z]+$/;
          if (!reg.test(this.username) || this.username.length < 2) {
            this.errorusername = true;
            this.inputError = true;
            this.errortext = "请输入正确的姓名";
            return;
          }
          if (this.username === "admin" && !this.isadminregister) {
            this.errorusername = true;
            this.inputError = true;
            this.errortext = "用户名不能为admin";
            return;
          }
          if (
            !this.password ||
            this.password.length < 6 ||
            !/^[a-zA-Z0-9]{4,23}$/.test(this.password)
          ) {
            this.inputError = true;
            this.passworderr = true;
            this.errortext = "请输入密码（由6-20位数字或字母组成）";
            return;
          }
          resetPass1 = "register"; //注册
        } else if (id == 3) {
          if (
            !this.password ||
            this.password.length < 6 ||
            !/^[a-zA-Z0-9]{4,23}$/.test(this.password)
          ) {
            this.inputError = true;
            this.passworderr = true;
            this.errortext = "请输入密码（由6-20位数字或字母组成）";
            return;
          }
          resetPass1 = "resetPass"; //找回密码
        }
        // if (id == 2) {
        //   resetPass1 = "resetPass";
        // } else if(id == 1) {
        //   resetPass1 = "register";
        // }

        if (
          this.contime > 3 ||
          (this.contime == 3 && this.goon == true && id == 2)
        ) {
          this.isovertime = true;
          return;
        }
        this.inputError = false;

        if (this.ishit == false && this.codetext == "获取验证码") {
          this.ishit = true;
          this.axios({
            method: "post",
            url: this.url + "/common/User/getCode",
            data: {
              type: resetPass1,
              mobile: this.iphone,
            },
          }).then((res) => {
            this.passworderr = false;
            if (id == 2) {
              this.contime++;
              this.goon = true;
            }
            this.ishit = false;

            if (res.data.status == 200) {
              this.isyzmshow = true;
              setTimeout(() => {
                this.isyzmshow = false;
              }, 3000);
              if (this.interval) {
                window.clearInterval(this.interval);
                this.interval = null;
              }

              this.miao = 60;
              this.codetext = "获取验证码";
              this.djsfun();
            } else {
              if (id == 1) {
                this.inputError = true;
                this.iphoneerror = true;
                this.errortext = res.data.message;
              } else if (id == 2) {
                this.inputError = true;
                this.iphoneerror = true;
                this.errortext = res.data.message;
              } else if (id == 3) {
                //this.codeerror = true;
                this.inputError = true;
                this.errortext = res.data.message;
              }
            }
          });
        }
      }
    },

    djsfun() {
      this.interval = setInterval(() => {
        this.codetext = this.miao + "(s)";
        if (this.miao > 0) {
          this.miao--;
        } else {
          this.miao = 60;
          if (this.interval) {
            window.clearInterval(this.interval);
            this.interval = null;
          }

          this.ishit = false;
          this.codetext = "获取验证码";
        }
      }, 1000);
    },
    hitregist() {
      this.iphone = "";
      this.password = "";
      this.issiginshow = false;
      this.isregister = true;
      this.isadminregister = false;
      this.passworderr = false;
      this.inputError = false;
      this.iphoneerror = false;
      this.codeerror = false;
    },
    hitforgetpasw() {
      this.iphone = "";
      this.password = "";
      this.code = "";
      this.issiginshow = false;
      this.isregister = false;
      this.isadminregister = false;
      this.passworderr = false;
      this.inputError = false;
      this.iphoneerror = false;
      this.codeerror = false;
      this.isforgetthepassword = true;
    },
    sexfun(id) {
      this.gender = id;
    },
    //返回登录
    gotosigin() {
      this.iphone = "";
      this.password = "";
      this.code = "";
      this.inputError = false;
      this.iphoneerror = false;
      this.codeerror = false;
      this.miao = 60;
      this.errorusername = false;
      if (this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
      this.ishit = false;
      this.codetext = "获取验证码";
      this.isregister = false;
      this.isadminregister = false;
      this.isforgetthepassword = false;
      this.issiginshow = true;
      this.passworderr = false;
    },

    //重置密码
    resetPassfun() {
      var myreg =
        /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
      if (!this.iphone) {
        this.inputError = true;
        this.iphoneerror = true;
        this.errortext = "请输入手机号码！";
        return;
      }
      if (!myreg.test(this.iphone)) {
        this.inputError = true;
        this.iphoneerror = true;
        this.errortext = "请输入有效手机号码！";
        return;
      }
      if (
        !this.password ||
        this.password.length < 6 ||
        !/^[a-zA-Z0-9]{4,23}$/.test(this.password)
      ) {
        this.inputError = true;
        this.passworderr = true;
        this.errortext = "请输入密码（由6-20位数字或字母组成）！";
        return;
      }
      var reg = /^(0|[1-9][0-9]*)$/;
      if (this.code.length != 4 || !reg.test(this.code)) {
        this.codeerror = true;
        this.inputError = true;
        this.errortext = "验证码有误，请重新输入！";
        return;
      }
      this.axios({
        method: "post",
        url: this.url + "/common/User/resetPass",
        data: {
          mobile: this.iphone,
          password: this.password,
          code: this.code,
        },
      }).then((res) => {
        if (res.data.status == 200) {
          this.isresetshow = true;
          setTimeout(() => {
            this.loginfun(1);
            this.isresetshow = false;
          }, 3000);
        } else {
          this.codeerror = true;
          this.inputError = true;
          this.errortext = res.data.message;
        }
      });
    },

    //登录
    loginfun(type) {
      let password = "";
      const myreg =
        /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
      if (!this.iphone) {
        this.inputError = true;
        this.iphoneerror = true;
        this.errortext = "请输入手机号码！";
        return;
      }

      if (!myreg.test(this.iphone)) {
        // 管理员登录的情况
        if (this.iphone !== "admin") {
          this.inputError = true;
          this.iphoneerror = true;
          this.errortext = "请输入有效手机号码！";
          return;
        }
      }

      if (type == 1) {
        if (
          !this.password ||
          this.password.length < 6 ||
          !/^[a-zA-Z0-9]{4,23}$/.test(this.password)
        ) {
          this.inputError = true;
          this.passworderr = true;
          this.errortext = "请输入密码（由6-20位数字或字母组成）！";
          return;
        }
        password = this.password;
      } else if (type == 2) {
        var reg = /^(0|[1-9][0-9]*)$/;
        if (this.code.length != 4 || !reg.test(this.code)) {
          this.codeerror = true;
          this.inputError = true;
          this.errortext = "验证码有误，请重新输入！";
          return;
        }
        password = this.code;
      }
      this.axios({
        method: "post",
        url: this.url + "/common/User/login",
        data: {
          type,
          mobile: this.iphone,
          password,
        },
      }).then((res) => {
        if (res.data.status == 200) {
          let startTime = res.data.data.validity_date;
          let end = new Date(startTime.replace(/-/g, "/")); //对比时间
          console.log(this.curdata.getTime(), end.getTime(), end, this.curdata);
          if(this.curdata.getTime() < end.getTime()){
     
          //当前时间比指定时间大
          localStorage.setItem("infonmass", JSON.stringify(res.data.data));
          localStorage.setItem("token", res.data.data.access_token);
          localStorage.setItem("teacher_id", res.data.data.id);
          localStorage.setItem("user_avatar", res.data.data.avatar);
          localStorage.setItem("user_name", res.data.data.name);
          window.localStorage.setItem("scoldid", res.data.data.school_id);
          if (this.interval) {
            window.clearInterval(this.interval);
            this.interval = null;
          }

          this.ishit = false;
          if (this.username === "admin") {
            this.$router.push({
              path: "/ams",
            });
          } else {
            if (res.data.data.school_id == 1) {
              if (res.data.data.is_regulars) {
                
                this.$router.push({
                  // path: "/seeoneindex",
                  path: "/index",
                });

              } else {
                this.$router.push({
                  //path: "/seeoneindex",
                  path: "/index",
                });
              }
            } else {
              if (res.data.data.is_regulars) {
                this.$router.push({
                  //path: "/indexhowm",
                  path: "/index",
                });
              } else {
                this.$router.push({
                  path: "/index",
                });
              }
            }
          }

           }else{
             this.$toast.fail('登录账号过期');
               //小于指定时间
           }

        } else {
          if (res.data.message.type === "admin") {
            this.hitregist();
            this.username = "admin";
            this.password = "123456";
            this.isadminregister = true;
            this.isregister = false;
          } else if (type == 1) {
            this.inputError = true;
            this.iphoneerror = true;
            this.errortext = res.data.message;
          } else {
            this.codeerror = true;
            this.inputError = true;
            this.errortext = res.data.message;
          }
          if (res.data.message.indexOf("禁用") != -1) {
            this.iszhjyshow = true;
            this.iszhjyshow = false;
          }
        }
      });
    },

    entmobile() {
      var myreg =
        /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
      if (this.iphone && myreg.test(this.iphone)) {
        this.inputError = false;
        this.iphoneerror = false;
        this.errortext = "请输入手机号码！";
      }
    },

    entpassword() {
      if (
        this.password &&
        this.password.length > 6 &&
        /^[a-zA-Z0-9]{4,23}$/.test(this.password)
      ) {
        this.inputError = false;
        this.passworderr = false;
      }
    },
    entpassword1() {
      if (
        !this.password ||
        this.password.length < 6 ||
        !/^[a-zA-Z0-9]{4,23}$/.test(this.password)
      ) {
        this.inputError = true;
        this.passworderr = true;
        this.errortext = "请输入密码（由6-20位数字或字母组成）";
      }
      if (
        this.password &&
        this.password.length > 6 &&
        /^[a-zA-Z0-9]{4,23}$/.test(this.password)
      ) {
        this.inputError = false;
        this.passworderr = false;
      }
    },
    entpcode() {
      var reg = /^(0|[1-9][0-9]*)$/;
      if (this.code.length != 4 || !reg.test(this.code)) {
        this.codeerror = true;
        this.inputError = true;
        this.errortext = "验证码有误，请重新输入！";
        return;
      }
      if (this.code.length == 4 && reg.test(this.code)) {
         this.codeerror = false;
         this.inputError = false;
      }
    },
    entusernamefun() {
      var reg = /^[\u0391-\uFFE5A-Za-z]+$/;
      if (!reg.test(this.username) || this.username.length < 2) {
          this.errorusername = true;
          this.inputError = true;
          this.errortext = "请输入正确的姓名";
      } else {
          this.errorusername = false;
          this.inputError = false;
      }
      if (this.username === "admin" && !this.isadminregister) {
          this.errorusername = true;
          this.inputError = true;
          this.errortext = "用户名不能为admin";
      }
    },

    closeposed() {
      this.touximg = "";
      this.iphone = "";
      this.showpassowedbox = false;
      this.inputError = false;
    },

    closesity() {
      this.issisyshow = false;
    },

    //退出系统 
    Exitsystem() {
      if (navigator.userAgent.indexOf("MSIE") > 0) {

        if(navigator.userAgent.indexOf("MSIE 6.0") > 0) {
          window.opener = null;
          window.close();
        } else {
          window.open("", "_top");
          window.top.close();
        }
      } else if (navigator.userAgent.indexOf("Firefox") > 0) {
        window.location.href = "about:blank ";//火狐默认状态非window.open的页面window.close是无效的
      } else {
        window.location.href = "about:blank";
        window.close();
      }
       this.exitFullscreen();
    },

    run(str) {
       var objShell = new XMLHttpRequest("wscript.shell");
       objShell.Run(str);
       objShell = null;
    },

    f_IsFullScreen() {
      return (
        document.body.scrollHeight == window.screen.height &&
        document.body.scrollWidth == window.screen.width
      );
    },


    //退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },

    init() {
      //初始化WebSocket
      if (typeof WebSocket === "undefine") {
        console.log("您的浏览器不支持websocket");
      } else {
        //实例化
        //实例化socket
        this.socket = new WebSocket(this.path, ["screen|0|handshakeXxx"]);
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getMessage;
        // 关闭连接
        this.socket.onclose = this.close;
      }
    },
    open() {
      console.log("websocket连接成功");
      var login_data = '{"class":"Index","action":"myFd"}';
      this.send(login_data);
    },
    error() {
      this.timlws++;
      if (this.timlws < 10) {
        var ste = ["screen|" + this.screen + "|handshakeXxx"];
        this.socket = new WebSocket(this.path, ste);
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getMessage;
        // 关闭连接
        this.socket.onclose = this.close;
      }
       console.log("socket已经关闭");
    },

    getMessage1(msg) {

    },

    send(params) {
      this.socket.send(params);
    },

    close(msg) {
      console.log("socket已经关闭");
      this.timlws++;
      if (this.timlws > 10) {
        return;
      }
      this.screen = localStorage.getItem("screend");
      if (this.timlws < 5) {
        var ste = ["screen|" + this.screen + "|handshakeXxx"];
        this.socket = new WebSocket(this.path, ste);
      } else {
        // screen|0|handshakeXxx|student、teacher、scoor|234
        // var ste = ["screen|0|handshakeXxx|" + this.lesson_id+ '|'+this.class_id];
        var ste = [
          "screen|0|handshakeXxx|" + this.typse + "|" + this.teacherid,
        ];
        this.socket = new WebSocket(this.path, ste);
        this.duankailianjie = true;
      }
      // 监听socket连接
      this.socket.onopen = this.open;
      // 监听socket错误信息
      this.socket.onerror = this.error;
      // 监听socket消息
      this.socket.onmessage = this.getMessage;
      // 关闭连接
      this.socket.onclose = this.close;
      //this.duankailianjie = true;
      console.log("socket已经关闭");
    },

    getMessage(msg) {
      if (JSON.parse(msg.data).fd) {
        this.screen = JSON.parse(msg.data).fd;
        window.localStorage.setItem("screen", this.screen);
        this.qrTeacher = {
          url: "请打开小程序课堂扫码上课" + this.screen.toString(),
          img: "static/img/qr-logo.png",
        };
        this.qrTeacher1 = {
          url: this.url + "/wechat/qr/teacher/login/" + this.screen.toString(),
          img: "static/img/qr-logo.png",
        };
      }

      var linsdak = JSON.parse(msg.data);
      if (linsdak.hasOwnProperty("event")) {
        if (linsdak.event == "sart_lesson") {
          // var url = 'https://text.seeonce.cn/screen?id=' + this.screen + '&lesson_id=' + linsdak.lesson_id + '&token=' + linsdak.token + '&type=' + linsdak.type
          var url =
            this.url +
            "/screen?id=" +
            this.screen +
            "&lesson_id=" +
            linsdak.lesson_id +
            "&type=" +
            linsdak.type;
          //var url='http://localhost:8080?id='+this.screen +'&lesson_id='+ linsdak.lesson_id +'&token='+linsdak.token+'&type='+linsdak.type
          localStorage.setItem("datalistr", JSON.stringify(linsdak));
          var login_data = linsdak.lesson_id;

          location.href = url;
        } else if (linsdak.event == "login") {
          if (linsdak.type == "success") {
            console.log(linsdak, "lww");

            let startTime = linsdak.content.validity_date;
            let end = new Date(startTime.replace(/-/g, "/")); //对比时间

            if(this.curdata.getTime() < end.getTime()){
            console.log(end, "ke");
            //当前时间比指定时间大
            localStorage.setItem("infonmass", JSON.stringify(linsdak.content));
            localStorage.setItem("token", linsdak.content.access_token);
            localStorage.setItem("teacher_id", linsdak.content.id);
            localStorage.setItem("user_avatar", linsdak.content.avatar);
            localStorage.setItem("user_name", linsdak.content.name);
            window.localStorage.setItem("scoldid", linsdak.content.school_id);
            if (this.interval) {
              window.clearInterval(this.interval);
              this.interval = null;
            }

            this.ishit = false;
            if (this.username === "admin") {
              this.$router.push({
                path: "/ams",
              });
            } else {
              if (linsdak.content.school_id == 1) {
                this.$router.push({
                  path: "/seeoneindex",
                  //path:'/index'
                });
              } else {
                if (linsdak.content.is_regulars) {
                  this.$router.push({
                    path: "/indexhowm",
                  });
                } else {
                  this.$router.push({
                    path: "/index",
                  });
                }
                // this.$router.push({
                //    path: "/indexhowm",
                //  // path:'/index'
                // });
              }
            }
             }else{
               this.$toast.fail('登录账号过期');
             }
          }
        }
      }

      this.reset();
    },

    openWin(url) {
      $("body").append(
        $('<a href="' + url + '" target="_blank" id="openWin"></a>')
      );
      document.getElementById("openWin").click(); //点击事件
      $("#openWin").remove();
    },

    reset() {
      clearInterval(this.timeoutObj);
      this.start();
    },
    // 用户登录状态,隔20秒重连一次
    start() {
      console.log("20秒的心跳重连");
      var that = this;
      that.timeoutObj = setInterval(function () {
        var login_data =
          '{"class":"Index","action":"heartbeat","params":{"time":"1234"}}';
        that.send(login_data);
      }, this.timeouts);
    },
    resizeCanvas(canvas) {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      this.originx = canvas.width / 2;
      this.originy = canvas.height / 2;
    },

    getMousePos(cvs, evt) {
      return;
      const rect = cvs.getBoundingClientRect();
      return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top,
      };
    },
  },
  mounted() {
    this.curdata = new Date();
    var EventTarget = EventTarget || false;
    if (EventTarget) {
      EventTarget.prototype.evt = function (event, callback) {
        return this.addEventListener(event, callback);
      };
    } else {
      window.evt = function (event, callback) {
        return this.addEventListener(event, callback);
      };
      document.evt = function (event, callback) {
        return this.addEventListener(event, callback);
      };
      Element.prototype.evt = function (event, callback) {
        return this.addEventListener(event, callback);
      };
    }

    if (this.url.indexOf("web.seeonce") != -1) {
       this.path = "wss://web.seeonce.cn:9502";
    } else if (this.url.indexOf("dat.seeonce.cn") != -1) {
       this.path = "wss://dat.seeonce.cn:9501";
    } else if (this.url.indexOf("welcome.seeonce.cn") != -1) {
       this.path = "wss://welcome.seeonce.cn:9502";
    }
    this.init();
     setTimeout(() => {
        this.ishowqr = true;
     }, 500);

    if (!window.localStorage.getItem("machine_code")) {
    }

    if (this.f_IsFullScreen()) {
      this.fullsecr = false;
    } else {
      this.fullsecr = true;
    }
  },

  components: {
    vueQrs,
    Particles,
    default: () => {},
  },

  destroyed() {
    window.localStorage.removeItem("course_ids");
  },
};
</script>

<style lang="less" scoped>
.icon {
  width: 1.5em;
  height: 1.5em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.loginmain {
  width: 100%;
  height: 100vh;
  position: relative;
}

.banner {
  position: relative;
}

.bannerImg {
  position: relative;
  height: 100vh;
  width: 100%;

  overflow: hidden;

  .active {
    transition: all 1s;

    img {
      width: 100%;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}

.login_box {
  position: absolute;
  // width: 77.142857rem;
  // height: 38.571429rem;
  width: 85.714286rem /* 1200/14 */;
  height: 38.714286rem /* 500/14 */;
  background: url("../../../static/img/loginboxbg.png");
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  overflow: hidden;
  top: calc((100% - 38.714286rem) / 2);
  left: calc((100% - 85.714286rem) / 2);
}

.login_midbox {
  width: 42.857143rem /* 600/14 */;
  position: relative;
  .locont_box {
    width: 34.571429rem;
    // margin-left: 3rem;
    margin: 0 auto;
  }
}
.smdelg_box {
  width: 5.714286rem /* 80/14 */;
  height: 5.714286rem /* 80/14 */;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  background: url("../../../static/img/saomadl.png");
  background-size: 100% 100%;
}
.fanwgowbox {
  position: absolute;
  left: 1.714286rem /* 24/14 */;
  top: 1.714286rem /* 24/14 */;
  cursor: pointer;
  font-size: 1.714286rem /* 24/14 */;
  font-weight: 400;
  text-align: left;
  color: #33ffff;
}
.login_titlebox {
  font-size: 2.571429rem /* 36/14 */;
  font-weight: 700;
  text-align: center;
  color: #33eeff;
  margin-top: 4.571429rem /* 64/14 */;
}
.clow_erbox {
  width: 22rem /* 308/14 */;
  height: 22rem /* 308/14 */;
  background: url("../../../static/img/ewmbg.png");
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 1.714286rem /* 38/14 */;
}
.twi_box {
  font-size: 1.428571rem /* 20/14 */;

  font-weight: 400;
  text-align: center;
  color: #ffffff;
}
.qerw_box {
  width: 42.857143rem /* 600/14 */;
  height: 38.571429rem;
  position: relative;

  .text_titop {
    font-size: 2.857143rem;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    position: absolute;
    z-index: 9;
    width: 100%;
    top: 3rem;
  }

  .text_content {
    font-size: 1.714286rem;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    position: absolute;
    z-index: 9;
    width: 100%;
    top: 8rem;
  }

  .sm_box {
    width: 38.571429rem;
    height: 38.571429rem;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
  }
}

.login_box1 {
  position: absolute;
  width: 45.714286rem;
  height: 45.714286rem;
  top: calc((100% - 45.714286rem) / 2);
  right: 16.785714rem;
  background: #ffffff;
  border: 1px solid #eaf0f7;
  border-radius: 9px;
  box-shadow: 0px 16px 40px -8px rgba(0, 55, 110, 0.2);
}

.login_midbox1 {
  width: 37.142857rem;
  margin: 0 auto;
  margin-top: 1.5rem;
}

.boxlist {
  margin-top: 1.142857rem /* 16/14 */;
  width: 31.028571rem;
  height: 4rem;

  border-radius: 4px;
  border: 1px solid #33eeff;
  background: #122a59;
  display: flex;
  justify-content: space-between;

  .leftbox {
    width: 4rem;
    height: 4rem;
    background: #122a59;
    border-radius: 4px 0px 0px 4px;
    color: #959595;
    font-size: 1.714286rem;
    line-height: 4rem;

    .icon {
      margin-top: 0.6rem;
    }
  }

  .rightinput {
    width: 27.014286rem;
    height: 4rem;
    overflow: hidden;

    input {
      line-height: 4rem;
      height: 4rem;
      font-size: 1.428571rem;
      font-weight: 400;
      color: #ffffff;
      background: none;
      border: none;
      width: 26.514286rem;
      padding-left: 0.5rem;
      -webkit-text-fill-color: #ffffff; //颜色是设置成你需要的颜色
    }
    input:-internal-autofill-selected {
      background-color: #122a59 !important;
      background-image: none !important;
      color: rgb(255, 255, 255) !important;

      box-shadow: inset 0 0 0 71.428571rem /* 1000/14 */ #122a59 !important;
    }

    input[type="text"]:focus {
      background: none;
      border: none;
    }
  }
}

.boxlist1 {
  margin-top: 2.857143rem;
  width: 36.942857rem;
  height: 5.714286rem;
  border-radius: 4px;
  border: 1px solid #dddddd;
  line-height: 5.714286rem;
  display: flex;
  justify-content: space-between;

  .leftbox {
    width: 5.714286rem;
    height: 5.714286rem;
    background: #f4f4f6;
    border-radius: 4px 0px 0px 4px;
    color: #959595;
    font-size: 1.714286rem;
    line-height: 4rem;

    .icon {
      margin-top: 1.6rem;
    }
  }

  .rightinput {
    width: 31.428571rem;
    height: 5.714286rem;

    input {
      line-height: 5.714286rem;
      height: 5.714286rem;
      font-size: 1.714286rem;
      font-weight: 400;
      color: #000000;
      background: none;
      border: none;
      width: 30.9rem;
      padding-left: 0.5rem;
    }
  }
}

.codebox {
  width: 18.714286rem;

  input {
    padding-left: 1.714286rem;
    width: 17rem;
    line-height: 4rem;
    height: 4rem;
    font-size: 1.428571rem;
    font-weight: 400;
    color: #fff;
    background: none;
    border: none;
  }
  input:-internal-autofill-selected {
    background-color: #122a59 !important;
    background-image: none !important;
    color: rgb(255, 255, 255) !important;
    box-shadow: inset 0 0 0 71.428571rem /* 1000/14 */ #122a59 !important;
  }
}

.lulwd {
  width: 1px;
  height: 1.714286rem;
  opacity: 1;
  background: #ccd0d6;
  margin-top: 1.3rem;
}

.lulwd1 {
  width: 1px;
  height: 1.714286rem;
  opacity: 1;
  background: #ccd0d6;
  margin-top: 2.2rem;
}

.codebtnbox {
  width: 13.357143rem;
  line-height: 4rem;
  height: 4rem;
  cursor: pointer;
  font-size: 1.714286rem;
  font-weight: 700;
  text-align: center;
  color: #33eeff;
}

.codebtnbox1 {
  width: 13.357143rem;
  line-height: 5.714286rem;
  height: 5.714286rem;
  cursor: pointer;
  font-size: 1.714286rem;
  font-weight: 700;
  text-align: center;
  color: #33eeff;
}

.loginbtn {
  width: 31.228571rem;
  height: 4rem;
  opacity: 1;
  background: #33eeff;
  border-radius: 0.285714rem /* 4/14 */;
  line-height: 4rem;
  font-size: 1.428571rem;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  color: #11144e;
  margin-top: 2.285714rem;
  cursor: pointer;
}

.loginbtn1 {
  width: 37.142857rem;
  height: 5.714286rem;
  opacity: 1;
  background: #29bbcc;
  border-radius: 4px;
  line-height: 5.714286rem;
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  margin-top: 3.428571rem;
  cursor: pointer;
}

.errorbox {
  width: 29.028571rem;
  height: 2.571429rem;
  line-height: 2.571429rem;
  opacity: 1;
  background: rgba(255, 29, 67, 0.1);
  border: 1px dashed #ff1d43;
  border-radius: 5px;
  margin-top: 2.285714rem;
  font-size: 1.142857rem;
  font-weight: 400;
  text-align: left;
  color: #ff1d43;
  padding-left: 2.285714rem;

  .icon {
    margin-top: 0.4rem;
    float: left;
  }
}

.errorbox1 {
  width: 29.028571rem;
  height: 2.571429rem;
  margin-top: 2.285714rem;
}

.logo_img {
  position: absolute;
  left: 2%;
  top: 4%;
  img {
    height: 3.428571rem;
  }
}

.bottomzw_box {
  width: 13.928571rem;
  display: flex;
  margin: 0 auto;
  justify-content: space-around;
  margin-top: 2.071429rem;

  .shuke {
    width: 1px;
    height: 1.142857rem;
    opacity: 1;
    background: #ccd0d6;
  }
}
.lowgsigbtn {
  cursor: pointer;
  width: 15.428571rem;
  font-size: 1.285714rem;
  font-weight: 700;
  text-align: center;
  color: #29bbcc;
  line-height: 1.142857rem;
  margin: 0 auto;
}
.inpuborder {
  border: 1px solid #f33845;
}

/deep/ .el-tabs__item.is-active {
  color: #000000;

  font-weight: bold;
  font-size: 1.714286rem;
}

/deep/ .el-tabs__item {
  font-size: 1.714286rem;
  color: #a5a6a8;
  margin-top: 1.142857rem;
  height: 3.857143rem;
}

/deep/ .el-tabs__active-bar {
  background-color: #29bbcc;
  height: 0.285714rem;
  width: 15.785714rem;
}

/deep/ .el-tabs__item:hover {
  color: #40c3c4;
  cursor: pointer;
}

.register_box {
  width: 37.142857rem;
  height: 47.642857rem;
  opacity: 1;
  background: #ffffff;
  border: 1px solid #eaf0f7;
  border-radius: 9px;
  box-shadow: 0px 16px 40px -8px rgba(0, 55, 110, 0.2);
  position: absolute;
  top: calc((100% - 47.642857rem) / 2);
  right: 18.571429rem;
}

.registtop_text {
  margin-top: 1.142857rem;
  width: 100%;
  text-align: center;
  height: 4.5rem;
  line-height: 4.5rem;
  font-size: 1.714286rem;
  font-weight: 700;

  color: #111214;
}

.regist_list {
  width: 31.228571rem;
  height: 4rem;
  line-height: 4rem;
  border: 1px solid #ccd0d6;
  border-radius: 5px;
  margin-top: 1.142857rem;
}

.resgist_ipnut {
  line-height: 4rem;
  height: 4rem;
  font-size: 1.428571rem;
  font-weight: 400;
  color: #ffff;
  background: none;
  border: none;
  width: 30.728571rem;
  padding-left: 0.5rem;
}

.sex_box {
  width: 100%;
  height: 3rem;
  margin-top: 1.142857rem;

  .rougs {
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
    border: 0.514286rem solid #29bbcc;
    float: left;
    cursor: pointer;
    margin-top: 0.8rem;
  }

  .rougs1 {
    width: 1.714286rem;
    height: 1.714286rem;
    border-radius: 50%;
    border: 1px solid #dedfe0;
    float: left;
    cursor: pointer;
    margin-top: 0.8rem;
  }

  .sextext {
    float: left;
    font-size: 1.428571rem;
    font-weight: 400;
    color: #3c3f42;
    margin-left: 0.8rem;
    line-height: 3.5rem;
  }
}

.cokebox {
  font-size: 1.285714rem;
  font-weight: 700;
  text-align: center;
  color: #29bbcc;
  margin-top: 0.6rem;
  cursor: pointer;
}

.tbox {
  position: fixed;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  left: 0;
  bottom: 0;
  height: 100vh;
  z-index: 99;
}

.czmgbox {
  width: 34.285714rem;
  height: 23.785714rem;
  position: absolute;
  left: calc((100% - 34.285714rem) / 2);
  top: calc((100% - 23.785714rem) / 2);
  background: url("../../../static/img/czcgbg.png");
  background-size: 100% 100%;
  z-index: 99;

  .sucestext {
    width: 100%;
    text-align: center;
    font-size: 2.142857rem;
    font-weight: 700;
    text-align: center;
    color: #28cc95;
    margin-top: 12.642857rem;
  }

  .loadtext {
    font-size: 1.428571rem;
    font-weight: 400;
    text-align: center;
    color: #363636;
    width: 100%;
    text-align: center;
    margin-top: 0.857143rem;
  }
}

.zhbox {
  width: 34.285714rem;
  height: 23.785714rem;
  position: absolute;
  left: calc((100% - 34.285714rem) / 2);
  top: calc((100% - 23.785714rem) / 2);
  background: url("../../../static/img/zhjy.png");
  z-index: 99;
  background-size: 100% 100%;

  .sucestext {
    width: 100%;
    text-align: center;
    font-size: 2.142857rem;
    font-weight: 700;
    text-align: center;
    color: #ff1d43;
    margin-top: 12.642857rem;
  }

  .loadtext {
    font-size: 1.428571rem;
    font-weight: 400;
    text-align: center;
    color: #363636;
    width: 100%;
    text-align: center;
    margin-top: 0.857143rem;
  }
}

.yzmbox {
  width: 34.285714rem;
  height: 23.785714rem;
  position: absolute;
  left: calc((100% - 34.285714rem) / 2);
  top: calc((100% - 23.785714rem) / 2);
  background: url("../../../static/img/yzmbg.png");
  z-index: 99;
  background-size: 100% 100%;
  .sucestext {
    width: 100%;
    text-align: center;
    font-size: 2.142857rem;
    font-weight: 700;
    text-align: center;
    color: #28cc95;
    margin-top: 12.642857rem;
  }

  .loadtext {
    font-size: 1.428571rem;
    font-weight: 400;
    text-align: center;
    color: #363636;
    width: 100%;
    text-align: center;
    margin-top: 0.857143rem;
  }
}

.ks_text {
  font-size: 2.571429rem;
  font-weight: 700;
  color: #111214;
  text-align: center;
  margin-top: 3.428571rem;
}

.one_numbox {
  display: flex;
  width: 30rem;
  margin: 0 auto;
  justify-content: space-between;
  margin-top: 8.428571rem;
  height: 16.071429rem;

  .addnewbtn {
    width: 12.142857rem;
    cursor: pointer;

    .xzh_box {
      width: 12.142857rem;
      height: 12.142857rem;
      line-height: 12.142857rem;
      border-radius: 50%;
      background: #29bbcc;
      font-size: 4rem;
      color: #fff;
      font-weight: bold;
    }

    .add_text {
      font-size: 1.714286rem;
      font-weight: 700;
      text-align: center;
      color: #29bbcc;
      margin-top: 0.857143rem;
    }
  }

  .one_uesrbox {
    width: 12.142857rem;
    cursor: pointer;

    .suer_imgbox {
      width: 12.142857rem;
      height: 12.142857rem;
      border-radius: 50%;

      img {
        width: 12.142857rem;
        height: 12.142857rem;
        border-radius: 50%;
      }
    }

    .username_text {
      font-size: 1.714286rem;
      font-weight: 400;
      text-align: center;
      color: #363636;
      margin-top: 0.857143rem;
    }
  }
}

.con_box {
  height: 37.928571rem;
  margin: 0 auto;
  margin-top: 1rem;
  width: 45.142857rem;
  overflow-y: auto;
  -ms-scroll-chaining: chained;
  -ms-overflow-style: none;
  -ms-content-zooming: zoom;
  -ms-scroll-rails: none;
  -ms-content-zoom-limit-min: 100%;
  -ms-content-zoom-limit-max: 500%;
  -ms-scroll-snap-type: proximity;
  -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
  -ms-overflow-style: none;

  .listbox {
    width: 9.714286rem;
    height: 12.428571rem;
    float: left;
    margin-top: 3.571429rem;
    margin-left: 4rem;
    cursor: pointer;

    .new_box {
      width: 9.714286rem;
      height: 9.714286rem;
      line-height: 9.714286rem;
      border-radius: 50%;
      background: #29bbcc;
      font-size: 3rem;
      color: #fff;
      font-weight: bold;
    }

    .new_text {
      font-size: 1.714286rem;
      font-weight: 700;
      text-align: center;
      color: #29bbcc;
      margin-top: 0.5rem;
    }

    .use_box {
      width: 9.714286rem;
      height: 9.714286rem;
      border-radius: 50%;

      img {
        width: 9.714286rem;
        height: 9.714286rem;
        border-radius: 50%;
      }
    }

    .use_nametext {
      font-size: 1.714286rem;
      font-weight: 400;
      text-align: center;
      color: #111214;
      margin-top: 0.5rem;
    }
  }
}

.con_box::-webkit-scrollbar {
  display: none;
}

.poswad_box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: linear-gradient(90deg, #4ca6ff, #7dd9e3 87%);

  .errorboxs {
    margin: 0 auto;
    margin-top: 1.142857rem;
    width: 34.285714rem;
    height: 3.428571rem;
    line-height: 3.428571rem;
    opacity: 1;
    background: #ffe9ed;
    border: 1px solid #ff1d43;
    border-radius: 5px;
    font-size: 1.428571rem;
    color: #ff1d43;
    font-weight: 400;
    text-align: left;

    .icon {
      margin-top: 0.5rem;
      float: left;
      margin-left: 1rem;
    }
  }

  .tx_box {
    width: 11.428571rem;
    height: 11.428571rem;
    margin: 0 auto;
    margin-top: 3.357143rem;

    img {
      width: 11.428571rem;
      height: 11.428571rem;
      border-radius: 50%;
    }
  }
}

.poswinputbox {
  width: 34.285714rem;
  height: 5.714286rem;
  line-height: 5.714286rem;
  background: #ffffff;
  border: 1px solid #ccd0d6;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: 2.285714rem;
  display: flex;
  justify-content: space-around;

  .leftbox {
    width: 5.714286rem;
    height: 5.714286rem;
    background: #f4f4f6;
    border-radius: 4px 0px 0px 4px;
    color: #959595;
    font-size: 1.714286rem;
    line-height: 5.714286rem;

    .icon {
      margin-top: 1.5rem;
    }
  }

  .mind_box {
    width: 23.428571rem;
    height: 5.714286rem;

    input {
      padding-left: 1.714286rem;
      width: 20.714286rem;
      height: 5.614286rem;
      line-height: 5.614286rem;
      font-size: 1.714286rem;
      font-weight: 400;
      text-align: left;
      color: #a5a6a8;
      background: none;
      border: none;
    }
  }

  .last_box {
    width: 4.571429rem;
    height: 4.571429rem;
    line-height: 4.571429rem;
    color: #fff;
    background: #29bbcc;
    font-size: 3.428571rem;
    font-weight: bold;
    margin-top: 0.571429rem;
    margin-right: 0.5rem;
    cursor: pointer;
  }
}

.cclose_btn {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;

  .icon {
    width: 120px;
    height: 120px;
  }
}

.Shutdown {
  position: fixed;
  right: 0rem;
  bottom: 0rem;
  cursor: pointer;

  .icon {
    width: 6rem;
    height: 6rem;
  }
}

.close_box {
  width: 100%;
  height: 100vh;
  background: url("../../../static/img/closebg.png");
  background-size: 100% 100%;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;

  .min_contbox {
    height: 17.142857rem;
    width: 48.571429rem;
    position: absolute;
    left: calc((100% - 48.571429rem) / 2);
    top: calc((100% - 17.142857rem) / 2);
    display: flex;
    justify-content: space-between;

    .divbox {
      width: 17.142857rem;
      height: 17.142857rem;
      cursor: pointer;
      margin: 0 auto;

      img {
        width: 17.142857rem;
        height: 17.142857rem;
      }

      .text_wod {
        font-size: 2.571429rem;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        margin-top: 1.714286rem;
      }
    }
  }
}

.scrfullbtn {
  width: 15.714286rem;
  height: 4.571429rem;
  opacity: 1;
  background: #29bbcc;
  border-radius: 8px;
  cursor: pointer;
  line-height: 4.571429rem;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  position: absolute;
  font-size: 1.714286rem;
  left: calc((100% - 15.714286rem) / 2);
  top: calc((100% - 4.571429rem) / 2);
}

.con_title {
  font-size: 4rem;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  position: absolute;
  width: 100%;
  top: 6%;

  .scen_title {
    width: 100%;
    font-size: 2rem;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
  }
}

.secen_imgbox {
  width: 24.357143rem /* 341/14 */;
  height: 19.142857rem /* 268/14 */;
  position: absolute;
  left: 4.571429rem /* 64/14 */;
  bottom: 5.714286rem /* 80/14 */;

  img {
    width: 24.357143rem /* 341/14 */;
    height: 19.142857rem /* 268/14 */;
  }
}

.qr_box {
  width: 14.285714rem /* 200/14 */;
  height: 14.285714rem;
  position: relative;
  z-index: 99;
  margin: 0 auto;
  margin-top: 15rem;
}

.canvas {
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  pointer-events: none;
}

#particles-js {
  width: 100%;
  height: 100vh;
  /* background-color: #000000; */
  background-color: #214;
  background: url("../../../static/img/loginimgbg.png");
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  top: 0;
}
.ingwbos_bxo {
  position: relative;
  width: 100%;
  height: 100vh;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue